import { createContext } from 'react';

import type { Organization, User } from '@raystack/frontier';

import type { OrganizationReadResponse } from '@src/clients/clerk/api';

interface IdentityContextType {
  activeOrg?: Organization;
  user?: User;
  organizations?: Organization[];
  activeOrgInfo?: OrganizationReadResponse;
  refetchUser?: () => void;
}

export const IdentityContext = createContext<IdentityContextType>({
  activeOrg: {} as Organization,
  user: {} as User,
  organizations: [],
  activeOrgInfo: undefined
});
